/*
 * @Author: zhengxiaowen
 * @Date: 2018-09-21 09:22:05
 * @Last Modified by: zhengxiaowen
 * @Last Modified time: 2018-11-26 16:07:56
 */

export default {
  state: {
    isNative: null,
    isDebug: null,
    location: null,
    keyboardDid: false,
    h5Header: {
      statusBarStyle: '',
      show: false,
    },
    router: null
  },
  getters: {
  },
  mutations: {
    SET_ROUTER(state,obj){
      // console.log(obj)
      state.router = obj
    },
    h5Header (state, flag) {
      try {
        state.h5Header = sessionStorage.h5Header ? JSON.parse(sessionStorage.h5Header) : {}
      } catch (error) {
        
      }
    },
    SET_NATIVE_FLAG (state, flag) {
      if (sessionStorage.isNative === 'true') {
        state.isNative = true
      } else {
        sessionStorage.isNative = flag
        state.isNative = flag
      }
    },
    SET_DEBUGGER (state, flag) {
      state.isDebug = flag
    },
    SET_LOCATION (state, data) {
      let location = null
      if (data) {
        location = JSON.parse(data)
      }
      state.location = location
    },
    REMOVE_LOCATION (state) {
      state.location = null
    },
    UPDATE_KEYBOARD_DID (state, flag) {
      state.keyboardDid = flag
    }
  },
  actions: {
  }
}



// WEBPACK FOOTER //
// ./src/common/store/SystemStore.js